import { awaitsSignedCopy, boundSigningOrdinals, hasCompletedSignatureDocument, isMandatorySignature, isSignatureCompletedBy } from './selectors';
export function signedCopyOf(document) {
    const completedCopyAvailable = hasCompletedSignatureDocument(document);
    const finishedCopy = completedCopyAvailable ? 'completed' : 'original';
    return {
        completedCopyAvailable,
        variants: {
            clientViewer: 'latest',
            clientDownload: finishedCopy,
            agreementPage: finishedCopy
        }
    };
}
export function signerProgressOf(param) {
    let { document, relationship, ordinal, completedThisSession = false, recordWaitOver = false } = param;
    const recorded = isSignatureCompletedBy(document, ordinal);
    return {
        completed: recorded || completedThisSession,
        ready: recorded || recordWaitOver,
        settled: recorded && !awaitsSignedCopy(document, relationship)
    };
}
export function unsignedMandatoryOrdinalsOf(document, relationship) {
    return isMandatorySignature(document) ? boundSigningOrdinals(document, relationship).filter((ordinal)=>!isSignatureCompletedBy(document, ordinal)) : [];
}
